module.exports = __webpack_public_path__ + "img/Ramo quebrado por Trator.e1a2ecaf.webp";